import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import moment from 'moment';
import 'moment/locale/ru';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { store } from './store';
import App from './App';
import { initAttrParamsAction } from './components/filter/actions';
import { initModuleAction } from './modules/actions';
import './index.scss';

moment.locale('ru');

const rootElem = document.getElementById(window.vpriemScheduleParams.rootElemID);
let queryParams = {};
const params = {
    typeView: rootElem.dataset.typeview !== undefined && rootElem.dataset.typeview !== '' ? +rootElem.dataset.typeview : null,
    speciality: rootElem.dataset.speciality !== undefined && rootElem.dataset.speciality !== '' ? JSON.parse(rootElem.dataset.speciality) : null,
    doctor: rootElem.dataset.doctor !== undefined && rootElem.dataset.doctor !== '' ? +rootElem.dataset.doctor : null,
    showFilter: rootElem.dataset.showfilter !== undefined && rootElem.dataset.showfilter !== '' ? +rootElem.dataset.showfilter : null,
};
const module = rootElem.dataset.module !== undefined && rootElem.dataset.module !== '' ? rootElem.dataset.module : null;

if (module) {
    store.dispatch(initModuleAction(module));
}

const { search, hash } = window.location;
if (search !== '') {
    const clearHash = hash.replace('#', '');
    const hashParams = clearHash !== '' ? new URLSearchParams(clearHash) : null;

    if (hashParams) {
        queryParams = {
            typeView: 'month',
            speciality: hashParams.get('speciality') ? [+hashParams.get('speciality')] : null,
            doctor: hashParams.get('doctor') ? +hashParams.get('doctor') : null,
            showFilter: null,
        };

        if (hashParams.get('doctor') && hashParams.get('speciality')) {
            queryParams = { ...queryParams, typeView: 'week' };
        } else if (hashParams.get('doctor')) {
            queryParams = { ...queryParams, typeView: 'week' };
        } else if (hashParams.get('speciality')) {
            queryParams = { ...queryParams, typeView: 'week' };
        }
        store.dispatch(initAttrParamsAction(queryParams));
    } else {
        store.dispatch(initAttrParamsAction(params));
    }
} else {
    store.dispatch(initAttrParamsAction(params));
}

ReactDOM.render(
    <Provider store={store}>
        <App />
        <ToastContainer position="top-right" newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable />
    </Provider>,
    rootElem
);
